import CarBreadcrumb from "../../commonComponents/breadcrumbs/CarBreadcrumb";
import CarDetail from "../../commonComponents/productDetail/CarDetail";

const CarVideoContainer = () => {
  return (
    <>
      <CarBreadcrumb type="car_video" mailClass="video-breadcrumbs" />
      <CarDetail type="car" />
    </>
  );
};

export default CarVideoContainer;
